(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['LoginService'];

    function NavbarController(LoginService) {
        var vm = this;

        vm.logout = function () {
            LoginService.logout();
        }
    }
})();
